// extracted by mini-css-extract-plugin
export default {"loginSuccessContainer":"LoginSuccess_loginSuccessContainer__g3pmM","loginSuccessTitle":"LoginSuccess_loginSuccessTitle__9YKeq"};